import { Controller } from "@hotwired/stimulus"
import { getString, setString } from "../utils/local_storage"

// Bench / Studio enclosure switch. The pre-paint <head> script stamps
// data-theme before first paint (?theme= -> localStorage -> prefers-color-scheme);
// this controller keeps the segmented latches, their LEDs and localStorage in
// sync once the bundle boots. Display bays read --bay, which neither theme
// overrides, so screens stay Display Black in both enclosures.
//
// Controller element: the .seg group holding the [data-theme-value] latches.
const KEY = "dg-theme"

export default class extends Controller {
  connect() {
    this.buttons = Array.from(this.element.querySelectorAll("[data-theme-value]"))
    // Defensive: honour a stored preference if the pre-paint script did not run.
    if (!document.documentElement.dataset.theme) {
      const stored = getString(KEY)
      if (stored) document.documentElement.dataset.theme = stored
    }
    this._onClick = this._onClick.bind(this)
    this.element.addEventListener("click", this._onClick)
    this._sync()
  }

  disconnect() {
    if (this._onClick) this.element.removeEventListener("click", this._onClick)
  }

  _onClick(event) {
    const button = event.target.closest("[data-theme-value]")
    if (!button || !this.element.contains(button)) return
    const theme = button.dataset.themeValue
    document.documentElement.dataset.theme = theme
    setString(KEY, theme) // raw string, matching the pre-paint script's read
    this._sync()
  }

  _sync() {
    const current = document.documentElement.dataset.theme === "studio" ? "studio" : "bench"
    this.buttons.forEach((button) => {
      const on = button.dataset.themeValue === current
      button.setAttribute("aria-pressed", String(on))
      const led = button.querySelector(".led")
      if (led) {
        led.classList.toggle("on", on)
        led.classList.toggle("on--signal", on)
      }
    })
  }
}
